import React, { useReducer, useState, useContext } from 'react';
import api from './ApiCall';
import { MODULE_LIST, MODULE_DETAILS, ModuleContext, CommonContext } from './../constant/ActionTypes';
import { moduleReducer } from './../reducer/moduleReducer';
import Loader from './../../common/Loader/Loader';

const initialState = {
    moduleList: [],
    moduleDetails: {}
}

const ModuleProvider = (props) => {
    const commonContext = useContext(CommonContext);

    const [moduleState, dispatch] = useReducer(moduleReducer, initialState);

    const [showLoader, setShowLoader] = useState(false);

    // { ModuleList }
    const getModuleList = (course_id, page=null, offset=null) => {
        let pageLink = '';
        if (page) {
            pageLink = `?page=${page}&itemSize=${offset}`;
        }

        api({ contentType: true, auth: true }).get(`ModuleService/getAll/course/${course_id}${pageLink}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: MODULE_LIST,
                    payload: response.data.result && response.data.result.content ? response.data.result.content : response.data.result
                });
                commonContext.updatePagination(response.data.result);
                if (
                    !(response.data.result && response.data.result.length > 0) ||
                    !(response.data.result && response.data.result.content && response.data.result.content.length > 0)
                ) {
                    commonContext.updateLoaderMsg('No data found')
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearModuleList = () => {
        dispatch({
            type: MODULE_LIST,
            payload: []
        });
    }
    
    // { ModuleDetails }

    const getModuleDetails = (module_id) => {
        api({ contentType: true, auth: true }).get(`ModuleService/getDetails/${module_id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: MODULE_DETAILS,
                    payload: response.data.result
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearModuleDetails = () => {
        dispatch({
            type: MODULE_DETAILS,
            payload: {}
        });
    }

    const addModule = (moduledetail,course_id) => {
        setShowLoader(true);
		let data = {
			course_id,
            description: moduledetail.description,
            name: moduledetail.name
        }
        api({ contentType: true, auth: true }).post('ModuleService/add', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getModuleList(course_id, 1, 25);
                commonContext.handleSnackbar(true, 'success', 'Module added successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Module cannot be added');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Module cannot be added');
            }
        });
    }
    
    const updateModuleDetails = (moduledetail,course_id) => {
        setShowLoader(true);
		let data = {
			id: moduledetail.id,
            description: moduledetail.description,
            name: moduledetail.name
        }
        api({ contentType: true, auth: true }).patch('ModuleService/update', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getModuleList(course_id, 1, 25);
                commonContext.handleSnackbar(true, 'success', 'Module updated successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Module cannot be updated');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Module cannot be updated');
            }
        });
    }
    
    const deleteModule = (moduleid,course_id) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).patch(`ModuleService/delete/${moduleid}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
				getModuleList(course_id, 1, 25);
                commonContext.handleSnackbar(true, 'success', 'Module deleted successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Module cannot be deleted');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Module cannot be deleted');
            }
        });
    }


    return (
        <ModuleContext.Provider
            value={{
                ...moduleState,
                getModuleList: getModuleList,
                getModuleDetails: getModuleDetails,
                clearModuleDetails: clearModuleDetails,
                addModule: addModule,
                updateModuleDetails: updateModuleDetails,
                deleteModule: deleteModule,
                clearModuleList: clearModuleList
            }}
        >
            {props.children}
            {showLoader && <Loader onlyLoading />}
        </ModuleContext.Provider>
    );
}

export default ModuleProvider;


// WEBPACK FOOTER //
// ./contexts/provider/ModuleContext.js